/**
 * KAN-956/KAN-964: API раздела "Встречи и перезвоны".
 * Правила отбора (типы шага, день в поясе организации, просрочка до 7 дней,
 * видимость менеджера) только на backend: api.services.today_steps.
 */
import { apiClient } from './client'
import type { ManagerBrief } from '@/types/manager'

export const TODAY_STEPS_URL = '/api/v1/dashboard/today-steps/'
export const TODAY_STEPS_MONTH_URL = '/api/v1/dashboard/today-steps/month/'

export interface TodayStepItem {
  client_id: string
  name: string
  phone: string | null
  avatar_url: string
  /** Время шага, ISO. */
  followup_at: string
  step_type: string
  /** Подпись вида шага ("Перезвон менеджера", "Визит"). */
  step_label: string
  note: string
  manager: ManagerBrief | null
  /** Шаг раньше начала сегодняшних суток организации. */
  overdue: boolean
}

export interface TodayStepsList {
  /** Выбранный день ГГГГ-ММ-ДД (по поясу организации). */
  date: string
  /** Сегодня ГГГГ-ММ-ДД по поясу организации. */
  today: string
  total: number
  /** Шаги выбранного дня. */
  items: TodayStepItem[]
  /** Просроченные (до 7 суток); только когда выбран сегодняшний день, иначе пусто. */
  overdue: TodayStepItem[]
  overdue_count: number
}

export interface TodayStepsMonth {
  /** ГГГГ-ММ */
  month: string
  /** Число шагов по дням месяца: {"2026-11-05": 3}; дней без шагов нет. */
  days: Record<string, number>
}

/** Шаги дня; без даты: сегодня по поясу организации. */
export async function getTodaySteps(date?: string): Promise<TodayStepsList> {
  const response = await apiClient.get<TodayStepsList>(TODAY_STEPS_URL, { params: date ? { date } : undefined })
  return response.data
}

/** Число шагов по дням месяца ГГГГ-ММ (отметки календаря). */
export async function getTodayStepsMonth(month: string): Promise<TodayStepsMonth> {
  const response = await apiClient.get<TodayStepsMonth>(TODAY_STEPS_MONTH_URL, { params: { month } })
  return response.data
}

export const todayStepsApi = { list: getTodaySteps, month: getTodayStepsMonth }
